import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SubscriptionTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "Current Plan",
      path: "/admin/subscriptions"
    },
    // {
    //   label: "Subscriptions",
    //   path: "/admin/add/subscription"
    // },
    {
      label: "Module Entitlement",
      path: "/admin/module-entitlement"
    },
    
   
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default SubscriptionTabs;